/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useInterview } from '../hooks/useInterview';

import * as Sebrae from '@sebrae/react-core';
import { useInterviewController } from '../../../hooks/controllers/interview-controller';
import { useMessage } from '../../../hooks/messages/useMessage';

const InterviewContext = React.createContext(null);

export function InterviewProvider({ children }) {
  const {
    clearInterview,
    error,
    interview,
    loadInterview,
    loading,
    moduleColors,
  } = useInterview();
  const { navigateTo, getRouteParam } = Sebrae.useSebraeRouter();

  const { sendUpdateBasicData } = useInterviewController();
  const { handleError } = useMessage();

  const saveBasicDataInterview = React.useCallback(
    async (interviewDTO) => {
      try {
        await sendUpdateBasicData(interviewDTO);
        return true;
      } catch (error) {
        console.error('Erro ao atualizar dados básicos:', error);
        handleError(
          error?.message || 'Erro ao tentar atualizar os dados básicos.',
        );
        return false;
      }
    },
    [sendUpdateBasicData],
  );
  React.useEffect(() => {
    const fetchInterview = async () => {
      try {
        const adminId = getRouteParam('id');
        await loadInterview(adminId ? Number(adminId) : null);
      } catch (error) {
        navigateTo('/candidato/erro');
      }
    };

    fetchInterview();
  }, []);

  const [formData, setFormData] = React.useState();
  const [radioId, setRadioId] = React.useState(0);

  const [respostas, setRespostas] = React.useState([]);

  //valores que vinheram da entrevista
  React.useEffect(() => {
    if (interview) {
      setFormData((prev) => ({
        ...prev,
        socialName: interview?.candidate?.socialName || '',
        birthDate: interview?.birthDate || '',
        phone: interview?.phone || '',
        emergencyContactName: '',
        emergencyContactPhone: '',
      }));
    }
  }, [interview]);

  const handleChangeFormData = React.useCallback((e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  return (
    <InterviewContext.Provider
      value={{
        clearInterview,
        error,
        interview,
        loadInterview,
        loading,
        moduleColors,
        handleChangeFormData,
        formData,
        radioId,
        setRadioId,
        saveBasicDataInterview,
        respostas,
        setRespostas,
      }}
    >
      {children}
    </InterviewContext.Provider>
  );
}

export function useInterviewContext() {
  const context = React.useContext(InterviewContext);

  if (!context) {
    throw new Error(
      'useInterviewContext deve ser usado dentro de InterviewProvider',
    );
  }

  return context;
}
